export enum OcbAgentStatus {
    Unknown = 0,
    Started = 1,
    Stopped = 2,
    NotInstalled = 4,
}
